import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { normalizeNodeId } from '@gt/para/shared/para-node-id.util';
import { ParaLmsDrawerContext } from '../models/para-drawer-context.type';

/**
 * Opens the PARA progress-table LMS slideout (drawer + iframe + scoring) without using /assessment.
 */
@Injectable({
	providedIn: 'root',
})
export class ParaLmsAssessmentService {
	private readonly openSubject = new Subject<any>();

	readonly open$ = this.openSubject.asObservable();

	requestOpen(partial: any, nodeId?: unknown, context?: Partial<ParaLmsDrawerContext>): void {
		const n = normalizeNodeId(nodeId);
		const ctx: ParaLmsDrawerContext = {
			nodeId: n ?? null,
			badgeColors: context?.badgeColors ?? null,
			highestChallenge: context?.highestChallenge ?? null,
			drawerHeader: context?.drawerHeader ?? null,
			phaseChipColor: context?.phaseChipColor ?? null,
			milestonesWithStatus: context?.milestonesWithStatus ?? null,
		};
		// Keep backward compat: old callers passed only a partial object.
		this.openSubject.next({ partial, context: ctx });
	}
}
